var _style, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGno(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#00A1BF;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 150,
    cy: 150,
    r: 150
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gnosis_logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "st1",
    d: "M195,122.3l-4.1,4.1c3.4,5.2,4.2,11.8,2,17.6c-3.8,10.4-15.2,15.9-25.7,12.1 c-1.4-0.5-2.8-1.2-4.1-2l-13.1,13.1l-11.4-11.5c-5.4,3.6-12.3,4.5-18.5,2.3c-10.7-3.8-16.3-15.6-12.5-26.2c0,0,0-0.1,0-0.1 c0.6-1.6,1.3-3.1,2.3-4.5l-4.9-4.9l-0.9,1.6c-15.5,25.3-7.5,58.3,17.8,73.8c8.4,5.1,18.1,7.9,27.9,7.9h0.1 c29.6,0,53.7-24,53.7-53.6c0-9.8-2.7-19.5-7.8-27.9L195,122.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    className: "st1",
    d: "M116.2,133.1c-1.4,1.9-2.2,4.3-2.2,6.7c0,6,4.9,10.9,10.9,10.9c2.4,0,4.8-0.8,6.7-2.3 L116.2,133.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    className: "st1",
    d: "M169.8,147.5c1.8,1.2,3.9,1.9,6.1,1.9c6,0,10.9-4.9,10.9-10.9c0-2.2-0.6-4.3-1.9-6.1 L169.8,147.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-4",
    className: "st1",
    d: "M150.3,159L106,114.5l1.8-1.9c10.9-11.6,26-18.1,41.9-18.1h0.1c16.3,0,31.8,6.9,42.7,19 l1.7,1.9L150.3,159z M113.2,114.5l37.1,37.2l36.6-36.4c-9.8-9.9-23.2-15.4-37.1-15.5h-0.1C136.1,99.7,123,105,113.2,114.5z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shape-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M101.4,187.6l-5.2-0.4c-22.1-1.4-52.5-6.9-72.1-24.6c-12.1-10.8-14.5-21.1-14.6-21.6l-0.6-3.2h80.3l-0.5,3 c-0.4,2.7-0.6,5.4-0.6,8.2c0,12.2,3.5,24.1,10.3,34.2L101.4,187.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M198.6,187.6l2.9-4.4c6.7-10.1,10.3-21.9,10.3-34c0-2.8-0.2-5.6-0.6-8.3l-0.4-3h80.3l-0.6,3.2 c-0.1,0.5-2.4,10.8-14.5,21.6c-19.7,17.7-50.2,23.2-72.2,24.6L198.6,187.6z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGno);
export default __webpack_public_path__ + "static/media/GNO.768034a77952072090be6a11ac267337.svg";
export { ForwardRef as ReactComponent };